import React from 'react';
import { RouteComponentProps } from 'react-router';
import { DatasourceId, NetworkId } from '../../types';
import { MapUpdateMessage } from '../../shared/windowMessages';
import { useSettings } from '../../contexts/SettingsContext';
import MapPage from '../../pages/MapPage';

const MapWidget: React.FC<
  RouteComponentProps<{
    networkId: NetworkId;
  }>
> = ({ match, history, location }) => {
  const { marker, aqiStandard, searchedLocation, viewport } = useSettings();

  // Post messages to parent page
  React.useEffect(() => {
    // Throttle the updates to once every 500ms using a timeout
    const timeoutId = setTimeout(() => {
      const msg = new MapUpdateMessage(
        viewport,
        searchedLocation,
        marker?.datasourceId ?? null,
        aqiStandard?.aqiStandardId ?? null
      );
      window.parent.postMessage(msg, '*');
    }, 500);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
    };
  }, [viewport, searchedLocation, marker?.datasourceId, aqiStandard]);

  const queryParams = new URLSearchParams(window.location.search);
  const datasourceId = (queryParams.get('datasourceId') ?? undefined) as DatasourceId | undefined;

  return (
    <MapPage
      match={{ ...match, params: { networkId: match.params.networkId, datasourceId } }}
      history={history}
      location={location}
    />
  );
};

export default MapWidget;
